module.exports = {
  // App Info
  appstore_link         : "https://apple.co/2KV4NC1",                                  // Enter App Store URL.
  playstore_link        : null,                                  // Enter Google Play Store URL.
  google_analytics_ID   : "UA-115750199-2",                                        // Enter Google Analytics ID or ""
  presskit_download_link: null,                                  // Enter a link to downloadable file or (e.g. public Dropbox link to a .zip file).
  video_or_screenshot   : "screenshot",                                           // "screenshot" or "video"
  app_url               : "https://www.playtoaster.com",                            // Domain of your website without path_prefix.
  path_prefix           : "/",                                                    // Prefixes all links. For cases when deployed to example.github.io/automatic-gatsbyjs-app-landing-page/.
  app_name              : "Toaster",
  app_price             : "Free",
  app_description       : "Compete with your friends to create the best MEMEs using your pics. Play games with your friends anywhere, anytime.",
  app_keywords          : ["Toaster", "MEME game", "social game", "party game"],

  // Personal Info
  your_name              : "2dx3",
  your_link              : "https://www.2dx3.com/",
  your_city              : "Washington, D.C.",
  email_address          : "2dx3interactive@gmail.com",
  linkedin_username      : null,
  facebook_username      : null,
  instagram_username     : null,
  twitter_username       : "",
  github_username        : null,
  youtube_username       : null,

  // Features List
  features               : [
    // {
    //   title: "GitHub Pages GatsbyJS Starter",
    //   description:
    //     "Designed for GitHub Pages and Netlify. Fork. Edit site-config.js. Upload screenshot/video. Push to gh-pages branch. Voilà!",
    //   fontawesome_icon_name: "magic",
    // },
    // {
    //   title: "iPhone Device Preview",
    //   description:
    //     "Preview your app in the context of an iPhone device. Five different device colors included.",
    //   fontawesome_icon_name: "mobile",
    // },
    // {
    //   title: "Video Support",
    //   description:
    //     "Preview app video on the iPhone device simply by placing your video files in the videos folder.",
    //   fontawesome_icon_name: "play-circle",
    // },
    // {
    //   title: "Optimized Performance",
    //   description:
    //     "No need to worry about page performance or optimizing images and videos. Everything is already configured for the best performance possible!",
    //   fontawesome_icon_name: "sync",
    // },
    // {
    //   title: "Easy to Tweak",
    //   description:
    //     "Tweak accent color, images, icons and transparency via the site-config.js file. No HTML/CSS needed.",
    //   fontawesome_icon_name: "adjust",
    // },
    // {
    //   title: "Feature List",
    //   description:
    //     "Add features (like this one) to your site via the site-config.js file. No HTML/CSS needed.",
    //   fontawesome_icon_name: "star",
    // },
    // {
    //   title: "Deploy to Netlify",
    //   description: "Easily deploy your GatsbyJS landing page to Netlify.",
    //   fontawesome_icon_name: "arrow-alt-circle-down",
    // },
    // {
    //   title: "Social Links",
    //   description:
    //     "Easily add social media accounts and contact info in the footer via the site-config.js file. No HTML/CSS needed.",
    //   fontawesome_icon_name: "link",
    // },
    // {
    //   title: "FontAwesome Support",
    //   description:
    //     "Pick custom Font Awesome icons for the feature list via the site-config.js file. No HTML/CSS needed.",
    //   fontawesome_icon_name: "info-circle",
    // },
  ],
  header_background             : "#2D2D2D",
  topbar_title_color            : "#FBFBFB",
  cover_overlay_color_rgba      : "#2D2D2D",
  device_color                  : "white",                          // Set to "black", "blue", "coral", "white", or "yellow"
  body_background_color         : "F8F7F7",
  primary_text_color            : "#2d2d2d",
  content_width                 : "1170px",
  font                          : `"Helvetica Neue", sans-serif`,
  link_color                    : "#1d63ea",
  app_title_color               : "#FBFBFB",
  app_price_color               : "#ffffff",
  app_description_color         : "#ffffff",
  feature_title_color           : "#000000",
  feature_text_color            : "#666666",
  feature_icons_foreground_color: "#1d63ea",
  feature_icons_background_color: "#e6e6e6",
  social_icons_foreground_color : "#666666",
  social_icons_background_color : "#e6e6e6",
  footer_text_color             : "#666666",
}
